<template>
  <div class="detail-box">
    <div class="detail-title">
      <div class="detail-title-big">{{$route.meta.title}}</div>
      <div class="detail-title-small">{{$route.meta.title}}</div>
    </div>
    <div class="detail-info">
      <div class="detail-info-title">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item v-for="(item,index) of humList" :key="index">{{ item.meta.title }}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <div class="detail-info-title-right">
          <el-input v-model="searchQuery.gjc" clearable placeholder="输入关键词，搜项目、公告、规则…" class="input-with-select"></el-input>
          <el-button type="primary" @click="searchList">查询</el-button>
        </div> -->
      </div>
      <div class="detail-info-content">
        <div>
          <p>江苏厚添产权交易经纪有限公司成立于2024年1月。注册资本1000万元。下属无锡厚添商业运营管理有限公司为京东拍卖江苏地区服务商。主要面向江苏省各级政府机关、国央企、产交所、商业机构提供资产处置业务，包括但不限于企业国有资产、行政事业资产、农村集体资产、金融资产、诉讼资产、自然资源、环境能源、文化产权、技术产权、数据资产等多品种的市场化交易，在服务国企改革、促进各类要素资源市场化流转、优化资产配置等方面发挥积极作用。</p>
          <p>公司依托京东大数据平台，不断发挥企业化运作优势，抢抓要素市场化配置改革，夯实“公平公正合法合规”基础，多维度拓展要素交易范围，不断做大平台规模，提高服务水平。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {

      tableData: [
        
      ],
      listType: 1,
      currentPage: 1,
      humList: [],
      total:0,
      searchQuery:{
        gjc:''
      }
    }
  },
  watch: {
    $route(to, from) {
      this.humList = to.matched
      // 在路由变化时执行的操作
    this.getList()

    }
  },
  created() {},
  mounted() {
    this.humList = this.$route.matched
    this.getList()
  },
  methods: {
    searchList(){
      this.currentPage = 1 
      this.getList()
    },
    getList(){
      let params = {
        pageNum:this.currentPage,
        category:this.$route.params.category,
        gjc:this.searchQuery.gjc
      }
      this.axios.get('https://admin.jshtcq.com/api/sy/noticeTable',{params}).then(res=>{
        this.tableData = res.data.rows
        this.total=res.data.total
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    },
    changeCurrentPage(index) {
      let path = '/xm/' + index.replaceAll('-', '/')
      this.$router.push({
        path: path
      })
    },
    viewDetail(row){
      this.$router.push({
        path:`/messageDetail/${row.noticeId}`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-submenu.is-active .el-submenu__title {
    border-bottom-color: #409eff;
    color: #0c6aec !important;
  }
}
.detail-box {
  background: #f7f7f7;

  .detail-title {
    width: 100%;
    height: 250px;
    background: url('./../assets/jsht/detail/detail_top_bg.png') left top
      no-repeat;
    background-size: 100% 100%;
    position: relative;
    .detail-title-big {
      font-family: YouSheBiaoTiHei;
      font-size: 150px;
      color: rgba(0, 101, 240, 0.12);
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 195px;
      line-height: 195px;
      margin-top: 16px;
    }
    .detail-title-small {
      font-family: YouSheBiaoTiHei;
      font-size: 52px;
      color: #0c6aec;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      height: 68px;
      line-height: 68px;
      margin-top: 108px;
    }
  }

  .detail-info {
    padding: 0 240px;

    .detail-info-title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 52px;

      .detail-info-title-right {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        .input-with-select{
          width: 300px;
          margin-right: 12px;
        }
      }
    }

    .detail-info-content {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      p{
        text-indent:20px;
        font-size: 18px;
      }

    }
  }
}
</style>